<template lang="pug">
v-container.pt-0.px-0(fluid)
    v-row
        v-data-table(v-if='products && products.length > 0' :headers="headers" :items="products" style="width: 100%")
            template(v-slot:item="{ item }" v-slot:scope="{ item }")
                tr(:key="item.id")
                    //- v-checkbox
                    td
                      v-checkbox(v-model="item.selected" @change="updateSelected(item)")
                    td(:style="getProductStock(item).showLowStockAlert ? 'border-left: 5px solid #FF5722' : 'border-left: 5px solid transparent'")
                      v-img.mx-auto(
                        contain
                        :src="getImage(item.pictures.imageInput1)"
                        height="65"
                        max-width="50"
                        )
                          template(v-slot:placeholder="")
                              v-row.fill-height.ma-0(align="center" justify="center")
                                  v-progress-circular(indeterminate="" color="primary")
                    td.primary--text.hover-cursor(v-text="item.name").product__title--table
                    td.text-left(v-if = 'item.type !== "bundle"' v-text="getProductStock(item).result")
                    td(v-else v-text="getBundleStock(item).result")
                    td.text-left(v-text="getProductPrice(item)")
</template>

<script>
  import productPlaceHolder from '@/assets/icons/products.png'
  export default {
    components: {},
    props: {},
    data () {
      return {
        headers: [
          {
            sortable: false,
            text: 'Mostrar',
            value: '',
            align: 'left',
          },
          {
            sortable: false,
            text: 'Imagen',
            value: 'imagen',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Nombre',
            value: 'name',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Stock',
            value: 'stock',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Venta',
            value: 'sale',
            align: 'left',
          },
        ],
        productPlaceHolder: productPlaceHolder,
        selected: true,
      }
    },
    computed: {
      currentShop () {
        return this.$store.getters['shops/getCurrentItem']
      },
      products () {
        try {
          if (this.currentShop && Object.keys(this.currentShop).length !== 0 && !!this.$store.getters['products/getItems']) {
            return this.$store.getters['products/getItems']
              .filter(item => {
                return !!(item.location && item.location[this.currentShop.id])
              })
          } else {
            const products = this.$store.getters['products/getItems']
            products.sort((a, b) => (a.name.toUpperCase() > b.name.toUpperCase()) ? 1 : -1)
            return products
          }
        } catch (err) {
          // console.log('ENTRA EN UN ERROR ', err)
          const products = this.$store.getters['products/getItems']
          products.sort((a, b) => (a.name.toUpperCase() > b.name.toUpperCase()) ? 1 : -1)
          return products
        }
      },
    },
    methods: {
      getRamdon (item) {
        if (item === '') return false
        return true
      },
      getProductStock (item) {
        try {
          let showLowStockAlert = false
          if (this.currentShop) {
            if (item.location[this.currentShop.id]) {
              if (item.lowStockAlert && parseFloat(item.location[this.currentShop.id].stock) <= parseFloat(item.lowStockAlert)) {
                // item.location[this.currentShop.id].showLowStockAlert = true
                showLowStockAlert = true
              } else {
                // item.location[this.currentShop.id].showLowStockAlert = false
                showLowStockAlert = false
              }
              if (item.magnitude) {
                return { result: item.location[this.currentShop.id].stock + ' ' + item.unit, showLowStockAlert: showLowStockAlert }
              } else {
                return { result: item.location[this.currentShop.id].stock, showLowStockAlert: showLowStockAlert }
              }
            } else {
              return ''
            }
          } else {
            let sum = 0
            for (const i in item.location) {
              if (item.location[i]) {
                if (item.lowStockAlert && parseFloat(item.location[i].stock) <= parseFloat(item.lowStockAlert)) {
                  // item.location[i].showLowStockAlert = true
                  showLowStockAlert = true
                } else {
                  // item.location[i].showLowStockAlert = false
                  showLowStockAlert = false
                }
                sum += +item.location[i].stock
              }
            }
            if (item.magnitude) {
              return { result: sum + ' ' + item.unit, showLowStockAlert: showLowStockAlert }
            } else {
              return { result: sum, showLowStockAlert: showLowStockAlert }
            }
          }
        } catch (err) {
          //
          const showLowStockAlert = false
          // console.log(err)
          if (item.magnitude) {
            return { result: item.sold + ' ' + item.unit, showLowStockAlert: showLowStockAlert }
          } else {
            return { result: item.sold, showLowStockAlert: showLowStockAlert }
          }
        }
      },
      getImage (url) {
        if (url === '') {
          return productPlaceHolder
        } else {
          return url
        }
      },
      getBundleStock (bundle) {
        const vm = this
        // let stock = 0;
        try {
          let showLowStockAlert = false
          const location = vm.currentShop
          const ingredients = bundle.ingredients
          let quantities = []
          if (location) {
            ingredients.forEach(function (el) {
              const currentItem = vm.allItems.find(item => item.id === el.id)
              if (currentItem) {
                if (currentItem.location[location.id]) { quantities.push(Math.floor(currentItem.location[location.id].stock / el.amount)) } else quantities.push(0)
              } else quantities.push(0)
            })
            const stock = Math.min(...quantities) || 0
            if (bundle.lowStockAlert && parseFloat(stock) <= parseFloat(bundle.lowStockAlert)) {
              // bundle.location[location.id].showLowStockAlert = true
              showLowStockAlert = true
            } else {
              // bundle.location[location.id].showLowStockAlert = false
              showLowStockAlert = false
            }
            return { result: stock, showLowStockAlert: showLowStockAlert }
          } else {
            let results = 0
            vm.allShops.forEach(function (loc) {
              quantities = []
              ingredients.forEach(function (el) {
                const currentItem = vm.allItems.find(item => item.id === el.id)
                if (currentItem && currentItem.location[loc.id]) {
                  // console.log(currentItem.location[loc.id].stock, el.name)
                  quantities.push(Math.floor(currentItem.location[loc.id].stock / el.amount))
                } else {
                  quantities.push(0)
                }
              })

              results += +Math.min(...quantities)
              const stock = +Math.min(...quantities) || 0
              if (bundle.location[loc.id] && bundle.lowStockAlert && parseFloat(stock) <= parseFloat(bundle.lowStockAlert)) {
                // bundle.location[loc.id].showLowStockAlert = true
                showLowStockAlert = true
              } else if (bundle.location[loc.id]) {
                // bundle.location[loc.id].showLowStockAlert = false
                showLowStockAlert = false
              }
            })
            return { result: results, showLowStockAlert: showLowStockAlert }
          }
        } catch (err) {
          // console.log(err)
          return 0
        }
      },
      getProductPrice (item) {
        try {
          if (this.currentShop && item.location[this.currentShop.id]) {
            if (item.location[this.currentShop.id].pricewithouttax) {
              return item.type === 'ingredient' ? 'N/A' : item.location[this.currentShop.id].pricewithouttax
            } else {
              return item.type === 'ingredient' ? 'N/A' : item.location[this.currentShop.id].price
            }
          } else if (item.price.salewithouttax) {
            return item.type === 'ingredient' ? 'N/A' : item.price.salewithouttax
          } else {
            return item.type === 'ingredient' ? 'N/A' : item.price.sale
          }
        } catch (err) {
          // console.log(err)
          if (item.price.salewithouttax) {
            return item.type === 'ingredient' ? 'N/A' : item.price.salewithouttax
          } else {
            return item.type === 'ingredient' ? 'N/A' : item.price.sale
          }
        }
      },
      updateSelected (product) {
        const vm = this
        const copyProduct = { ...product }
        copyProduct.location[vm.currentShop.id].selected = product.selected
        delete product.selected
        vm.$store.dispatch('products/updateItem', { payload: copyProduct, message: [`Se cambio la visualización para el producto ${copyProduct.name} en la tienda ${copyProduct.location[vm.currentShop.id].name}`] })
      },
    },
  }
</script>

<style lang="scss" scoped></style>
